
import {
  Component,
  Mixins,
  ActionButtonConfig,
  FormPageMixins,
  appConst,
  Watch,
} from "@/lib";
import DeclareCustoms from "@/store/modules/shipment/declarecustoms/entity";

@Component
export default class CustomsDeclaration extends FormPageMixins {
  model = new DeclareCustoms();
  loading: boolean = false;
  productList: Array<any> = new Array<any>();
  isOpenModify: boolean = false;// 是否打开修改操作

  setSizeUnit(unit) {
    return unit === this.$appconst.unit.size;
  }
  setdotNumber(isSizeUnit) {
    return isSizeUnit ? 2 : 0;
  }

  quantity(row) {
    let dotNumber = this.setdotNumber(this.setSizeUnit(row.unit));
    return !!row.quantity || row.quantity === 0 ? row.quantity.toFixed(dotNumber) : row.quantity
  }

  async created() {
    Object.assign(this.config, {
      // getAction: "system/check-point/get",
      labelWidth: 220,
      pageTitleL: "app.DeclareCustoms.List",
      getAction: "shipment/declarecustoms/getDeclareCustomsList",
      okAction: "shipment/declarecustoms/updateDeclareCustomsList",
      isRedirectIndex: false,
    });
  }
 async  nextstep() {
  this.$router.push({ name: "declarecustoms.productelement", query: {id:this.model.id.toString()} });
}
 async saveback() {
    (this.$refs["form-page"] as any).formValidate(async (model: any) => {
      this.loading = true;
      try {
        await this.$store.dispatch({ type: this.config.okAction, data: this.model });;
        
        this.$Message.success(this.L("Tip.SavedSuccessfully"));
        await this.changebutton();
      } finally {
        this.loading = false;
      }
    });

    //this.model.isComPdf=true;
  }
  openModify() {
    this.isOpenModify = true;
  }
  async changebutton() {
   await this.$store.dispatch({
            type: "shipment/declarecustoms/getDeclareCustomsList",
            id: this.model.id,
          });
     this.model = this.$util.assign(this.record) as DeclareCustoms;
     
   this.$router.push({ name: "declarecustoms.productelement", query: {id:this.model.id.toString()} });
  }
  //   @Watch("record.declareProductList", { deep: true })
  //   watchdeclareProductList(value, oldvalue) {
  // let tt=value;
  //       let zz=oldvalue;
  //       debugger
  //     let List = this.model.declareProductList.filter(
  //       (x) => x.itemIndexNumber == value
  //     );
  //     let oldList = this.model.declareProductList.filter(
  //       (x) => x.itemIndexNumber == oldvalue
  //     );
  //     if (List[0].productCode !== oldList[0].productCode) {
  //       this.$Message.warning({
  //         content: this.L("错误"),
  //         duration: 3,
  //       });
  //       return;
  //     }
  //     List[0].quantity = oldList[0].quantity + List[0].quantity;
  //     List[0].totalNetWeight = oldList[0].totalNetWeight + List[0].totalNetWeight;
  //     List[0].totalAmount = oldList[0].totalAmount + List[0].totalAmount;
  //     let intex = this.model.declareProductList.findIndex(
  //       (x) => x.itemIndexNumber === oldvalue
  //     );
  //     this.model.declareProductList.splice(intex, 1);
  //   }
  rowClassName(row, index) {
    return "hi-table-error-row";
  }
  get record() {
    let tt = this.$store.state.shipment.declarecustoms.declareCustomsList;
    return tt;
  }

  get column() {
    return [
      this.$util.render.baseColumn("app.DeclareCustoms.ItemIndexNumber", null, {
        slot: "itemIndexNumber",
        width: 100,
      }),
      this.$util.render.baseColumn("app.ProductName.Code", null, {
        slot: "productCode",
        minWidth: 200,
      }),
      this.$util.render.baseColumn("app.DeclareCustoms.ProductName", null, {
        slot: "productName",
        minWidth: 300,
      }),
      this.$util.render.baseColumn("app.DeclareCustoms.QuantityAndUnit", null, {
        slot: "quantity",
        minWidth: 200,
      }),
      //   this.$util.render.baseColumn("app.DeclareGroup.Unit", null, {
      //     slot: "unit",
      //     minWidth: 100,
      //   }),
      this.$util.render.baseColumn("app.DeclareGroup.TotalNetWeight", null, {
        slot: "totalNetWeight",
        minWidth: 200,
      }),
      this.$util.render.baseColumn(
        "app.DeclareCustoms.TotalAndCurrency",
        null,
        {
          slot: "totalAmount",
          minWidth: 200,
          render: (h: any, params: any) => {
            return [
              h(
                "span",
                this.model.currency +
                  " " +
                  this.$util.format.amount(params.row.totalAmount)
              ),
            ];
          },
        }
      ),
      // this.$util.render.baseColumn("app.Factory.FactoryName", null, {key: "factoryName", width: 108}),
      this.$util.render.baseColumn("app.DeclareCustoms.DomesticSourceOfGood", null, {key: "domesticSourceOfGood", width: 108}),
    ];
  }

  itemIndexNumberList(declareProduct) {

    let list = [];
    let List = this.model.declareProductList.filter(
      (x) => (x.productCode == declareProduct.productCode && x.productName == declareProduct.productName && x.productNameEn == declareProduct.productNameEn)
    );
    for (let k in List) {
      list.push({ value: List[k].itemIndexNumber, displayText:List[k].itemIndexNumber });
    }
    return list;
  }

  temIndexNumberChange(value, oldList,index) {

    let List = this.model.declareProductList.find(
      (x) => x.itemIndexNumberOld == value
    );
    //如果商品编码不同就不能合并
    if (List.productCode !== oldList.productCode && List.productName !== oldList.productName && List.productNameEn !== oldList.productNameEn) {
   oldList.itemIndexNumber=oldList.itemIndexNumberOld
    this.$set(this.model.declareProductList,index,oldList)
      this.$Message.warning({
        content: this.L("app.DeclareCustoms.ErrorProductCode"),
        duration: 3,
      }); 
   // oldList.itemIndexNumber=oldList.itemIndexNumberOld
    //this.$set(this.model.declareProductList,index,oldList)
      return false;
    }
    List.quantity = oldList.quantity + List.quantity;
    List.totalNetWeight = oldList.totalNetWeight + List.totalNetWeight;
    List.totalGrossWeight = oldList.totalGrossWeight + List.totalGrossWeight;
    List.totalAmount = oldList.totalAmount + List.totalAmount;
    let intex = this.model.declareProductList.findIndex(
      (x) => x.itemIndexNumberOld === oldList.itemIndexNumberOld
    );
    this.model.declareProductList.splice(intex, 1);

  }

  async download() {
    this.loading = true;
    let response = await this.$store.dispatch({
      type: "shipment/declarecustoms/exportCustomsForm",
      data: { id: this.model.id },
    });

    this.loading = false;
    let name = response.headers["content-disposition"].split("=")[1];
    this.$util.downloadFile(response.data, decodeURI(name));
  }

  get regulatoryApproachList() {
    return this.getCodeListByCategory(appConst.codeCategory.regulatoryApproach);
  }
}
